// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notify-body[data-v-cd94f316] {
  background-color: var(--bg-color);
  color: var(--font-color);
  border-radius: 6px;
  width: var(--notify-width);
  height: var(--notify-height);
  box-shadow: var(--electron-notyfy-bg-color);
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  opacity: 1.0;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
.notify-body .icon-image[data-v-cd94f316] {
  margin-left: 10px;
}
.notify-body .icon[data-v-cd94f316] {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: var(--elem-red-color);
  color: white;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}
.notify-body .info-section[data-v-cd94f316] {
  margin-left: 10px;
  margin-right: 10px;
  overflow: hidden;
}
.notify-body .info-section > *[data-v-cd94f316] {
  color: var(--notyfy-title-subtitle-color);
}
.notify-body .info-section > *[data-v-cd94f316]:first-child {
  font-weight: bold;
  color: var(--font-color);
}
.notify-body .info-section .header[data-v-cd94f316] {
  display: block;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notify-body .info-section .title[data-v-cd94f316] {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notify-body .info-section .subtitle[data-v-cd94f316] {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 345px;
}
.notify-body i.fa-times[data-v-cd94f316] {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 10px;
  transform: translate(10px, -10px);
  cursor: pointer;
  color: #D1D1D1;
}
.notify-body i.fa-times[data-v-cd94f316]:hover {
  color: #7F7F7F;
}
.slide-fade-enter-active[data-v-cd94f316] {
  transition: all .3s ease;
}
.slide-fade-leave-active[data-v-cd94f316] {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter[data-v-cd94f316],
.slide-fade-leave-to[data-v-cd94f316] {
  transform: translateY(-20px);
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/notification/CustomNotification.vue"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iDAAiD;AACnD;AACA;;EAEE,4BAA4B;EAC5B,UAAU;AACZ","sourcesContent":[".notify-body[data-v-cd94f316] {\n  background-color: var(--bg-color);\n  color: var(--font-color);\n  border-radius: 6px;\n  width: var(--notify-width);\n  height: var(--notify-height);\n  box-shadow: var(--electron-notyfy-bg-color);\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  opacity: 1.0;\n  user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n  -webkit-touch-callout: none;\n}\n.notify-body .icon-image[data-v-cd94f316] {\n  margin-left: 10px;\n}\n.notify-body .icon[data-v-cd94f316] {\n  height: 50px;\n  width: 50px;\n  border-radius: 50%;\n  background-color: var(--elem-red-color);\n  color: white;\n  margin-left: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n}\n.notify-body .info-section[data-v-cd94f316] {\n  margin-left: 10px;\n  margin-right: 10px;\n  overflow: hidden;\n}\n.notify-body .info-section > *[data-v-cd94f316] {\n  color: var(--notyfy-title-subtitle-color);\n}\n.notify-body .info-section > *[data-v-cd94f316]:first-child {\n  font-weight: bold;\n  color: var(--font-color);\n}\n.notify-body .info-section .header[data-v-cd94f316] {\n  display: block;\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.notify-body .info-section .title[data-v-cd94f316] {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.notify-body .info-section .subtitle[data-v-cd94f316] {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 345px;\n}\n.notify-body i.fa-times[data-v-cd94f316] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 10px;\n  transform: translate(10px, -10px);\n  cursor: pointer;\n  color: #D1D1D1;\n}\n.notify-body i.fa-times[data-v-cd94f316]:hover {\n  color: #7F7F7F;\n}\n.slide-fade-enter-active[data-v-cd94f316] {\n  transition: all .3s ease;\n}\n.slide-fade-leave-active[data-v-cd94f316] {\n  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.slide-fade-enter[data-v-cd94f316],\n.slide-fade-leave-to[data-v-cd94f316] {\n  transform: translateY(-20px);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
